const TRIBE_FORUMS = {
  Investors: 'system_groups_investors',
  RealInvestors: 'system_groups_real_investors',
  UBDI: 'system_groups_ubdi_0'
}

export default TRIBE_FORUMS
